import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Spin } from "antd";
import { useOrganizations } from "organizations/queries";
import { buildDashboardPath } from "shared/utils/paths";
import { useBoundStore } from "store";
import { Organizations } from "./Organizations";

export const OrganizationsLoader = () => {
  const navigate = useNavigate();
  const { tenant, setOrganizations, setCurrentOrganization } = useBoundStore();
  const { data, isLoading } = useOrganizations(tenant?.id, { enabled: !!tenant?.id });

  useEffect(() => {
    if (isLoading || !data) return;

    setOrganizations(data);

    if (data.length === 1) {
      // Single organization - go directly to dashboard
      const organization = data[0];
      setCurrentOrganization(organization);
      navigate(buildDashboardPath(organization), { replace: true });
    }
  }, [data, isLoading, navigate, setOrganizations, setCurrentOrganization]);

  // Show loading state while fetching
  if (isLoading || !data) {
    return <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}><Spin /></div>;
  }

  // If no single org to auto-navigate to, show the selector/empty state
  if (data.length !== 1) {
    return <Organizations />;
  }

  return null;
};
